export const ConsumerNetIncomeSalaryStyles = {
  root: 'w-full sm:max-w-xs',
  header: 'text-coolGray900 text-14px mb-5 font-black text-left',
  container: 'grid grid-cols-3',
  column: 'text-center',
  secondaryText: 'text-blue300 text-13px mb-2 font-bold',
  label: 'text-14px mb-5',
}
